import { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { Btn, H3, P } from "../../../../../AbstractElements";
import CreateCompanyJobsForm from "./CreateCompanyJobsForm";
import { PlusSquare } from "react-feather";

interface CreateModalProps {
  company_code: string;
}

const CreateCompanyJobsModal: React.FC<CreateModalProps> = ({
  company_code,
}) => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  return (
    <>
      <Btn
        color="primary"
        onClick={toggle}
        style={{ display: "flex", alignItems: "center", gap: "2px" }}
      >
        <PlusSquare size={16} />
        Create New Job
      </Btn>
      <Modal isOpen={modal} toggle={toggle}>
        <div className="modal-toggle-wrapper social-profile text-start dark-sign-up">
          <ModalHeader className="border-0">
            <H3>Create New Job</H3>
            <P className="f-w-300" style={{ margin: 0 }}>
              Fill in the details below.
            </P>
          </ModalHeader>

          <CreateCompanyJobsForm company_code={company_code} toggle={toggle} />
        </div>
      </Modal>
    </>
  );
};
export default CreateCompanyJobsModal;
